import React, { useContext,useLayoutEffect, useState } from 'react';
import {AlignCenter, Grid } from 'react-feather';
import { Link } from 'react-router-dom';
import { Image } from '../../AbstractElements';
import CubaIcon from '../../assets/images/logo/logo.png';
import CustomizerContext from '../../_helper/Customizer';

const SidebarLogo = () => {
  const { mixLayout,setToggleIcon, toggleSidebar, toggleIcon, layout, layoutURL } = useContext(CustomizerContext);
  const [sidebartoggle, setSidebartoggle] = useState(false); 
  const width = useWindowSize();

  const openCloseSidebar = () => {
    toggleSidebar(!toggleIcon);
  };

  function useWindowSize() {
    const [size, setSize] = useState([0, 0]);
    useLayoutEffect(() => {
      function updateSize() {
        setSize([window.innerWidth, window.innerHeight]);
        if (window.innerWidth <= 991) {
        setToggleIcon(true);
          setSidebartoggle(true);
        } else {
        setToggleIcon(false);
          setSidebartoggle(false);
        }
      }
      window.addEventListener("resize", updateSize);
      updateSize();
      return () => window.removeEventListener("resize", updateSize);
    }, []);
    return size;
  }

  const responsive_openCloseSidebar = (toggle) => {
    if (width <= 991) {
      toggleSidebar(!toggle);
      document.querySelector(".sidebar-wrapper").className = "sidebar-wrapper ";
      document.querySelector(".bg-overlay1").classList.add("active");
    } else {
      if (toggle) {
        toggleSidebar(!toggle);
        document.querySelector(".sidebar-wrapper").className = "sidebar-wrapper close_icon ";
      } else {
        console.log("991 54 else", toggle);
        toggleSidebar(!toggle);
        document.querySelector(".sidebar-wrapper").className = "sidebar-wrapper ";
      }
    }
  };

  const layout1 = localStorage.getItem("sidebar_layout") || layout;

  return (
    <div className='logo-wrapper'>
{/*
{layout1 !== 'compact-wrapper dark-sidebar' && layout1 !== 'compact-wrapper color-sidebar' && mixLayout ? (
        <Link to={`${process.env.PUBLIC_URL}/dpsm/home`}>
          <Image attrImage={{ className: 'img-fluid d-inline', src: `${CubaIcon}`, alt: '' }} />
        </Link>
      ) : (
        <Link to={`${process.env.PUBLIC_URL}/dpsm/home`}>
          <Image attrImage={{ className: 'img-fluid d-inline', src: `${require('../../assets/images/logo/logo_dark.png')}`, alt: '' }} />
        </Link>
      )}  */}
      <div className='back-btn' onClick={() => openCloseSidebar()}>
        <i className='fa fa-angle-left' style={{fontSize:30}}></i>
      </div>
       {/*<div className='toggle-sidebar' onClick={openCloseSidebar}>
       <Grid className='status_toggle middle sidebar-toggle'  />
      </div>*/}
      
      
        <Link to={`${process.env.PUBLIC_URL}/eservices/home`}>
          <Image attrImage={{ className: 'img-fluid d-inline', src: `${CubaIcon}`, alt: '', width:"100%" }} />
        </Link>
        <div className="toggle-sidebar" onClick={() => responsive_openCloseSidebar(sidebartoggle)} style={window.innerWidth <= 991 ? { display: "block" } : { display: "none" }}>
          <AlignCenter className="status_toggle middle sidebar-toggle" id="sidebar-toggle" />
        </div> 
      <div className='back-btn ' onClick={() => openCloseSidebar()} style={{position:"relative", top:13}}>
         <AlignCenter className="status_toggle middle sidebar-toggle" id="sidebar-toggle" />
      </div>
      
     
     
    </div>
  );
};

export default SidebarLogo;
